var React = require('react');

function Gift (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M3 9a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9zM12 8v13","key":0}),React.createElement("path",{"d":"M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7M7.5 8a2.5 2.5 0 1 1 0-5c.965-.017 1.91.451 2.713 1.343C11.015 5.235 11.638 6.51 12 8c.362-1.49.985-2.765 1.787-3.657.803-.892 1.748-1.36 2.713-1.343a2.5 2.5 0 0 1 0 5","key":1})]));
}

Gift.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Gift;

Gift.default = Gift;
